import Button from 'components/common/Button';
import useBottomSheet from 'hooks/common/useBottomSheet';

const PrimeGemCostConfirm = () => {
  const { closeWithAnimation, sheets } = useBottomSheet();
  const sheet = sheets.PrimeGemCostConfirm;
  const data = (sheet?.data ?? {}) as { cost?: number };
  const cost = data.cost ?? 0;

  const handleConfirm = () => {
    closeWithAnimation('PrimeGemCostConfirm', { data: { confirmed: true } });
  };

  const handleCancel = () => {
    closeWithAnimation('PrimeGemCostConfirm', { data: { confirmed: false } });
  };

  return (
    <div className="flex h-full w-full flex-col items-center gap-[var(--spacing-lg)]">
      <div className="flex w-full flex-col items-center gap-[var(--spacing-xs)]">
        <div className="typography-title-md text-center text-dialog-txt-default">{brsc.gem_setting_1}</div>
        <div className="typography-body-sm break-keep text-center text-dialog-txt-secondary">{brsc.gem_setting_2.replace('$param', cost)}</div>
      </div>
      <div className="flex w-full items-center justify-center gap-[var(--spacing-sm)] rounded-lg bg-base-bg-subtle px-[var(--spacing-lg)] py-[var(--spacing-2xl)]">
        <img src="/imgweb/prime/gem.png" alt="gem" className="h-10 w-10" />
        <div className="text-4xl font-bold text-dialog-txt-default">{cost}</div>
      </div>
      <div className="flex w-full items-center justify-center gap-[var(--spacing-sm)]">
        <Button onClick={handleCancel} style={{ color: 'btn-bg-normal', icon: { name: bassets.bermuda.icon_set.close.svg, size: 24 } }} className="h-14 min-w-14 flex-grow-0" />
        <Button
          onClick={handleConfirm}
          style={{ text: brsc.confirm, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'lg', fontTheme: 'typography-headline-lg' }}
          className="h-14"
        />
      </div>
    </div>
  );
};

export default PrimeGemCostConfirm;
